(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4346,9131],{

/***/ 12453:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getGAUserID = function getGAUserID() {
  try {
    var trackers = ga.getAll();
    var i, len;

    for (i = 0, len = trackers.length; i < len; i += 1) {
      if (trackers[i].get("trackingId") === "UA-186465270-2") {
        return trackers[i].get("clientId");
      }
    }
  } catch (e) {}

  return false;
};

/* harmony default export */ __webpack_exports__["Z"] = (getGAUserID);

/***/ }),

/***/ 92559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);



var sendData = /*#__PURE__*/function () {
  var _ref2 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
    var api, data, token, endpoint, headers, options, response;
    return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api = _ref.api, data = _ref.data, token = _ref.token;
            endpoint = api;
            headers = {
              "Content-Type": "application/json",
              "captcha-response": token
            };
            options = {
              method: "POST",
              headers: headers,
              body: JSON.stringify(data)
            };
            _context.next = 6;
            return fetch(endpoint, options);

          case 6:
            response = _context.sent;
            _context.next = 9;
            return response.json();

          case 9:
            return _context.abrupt("return", _context.sent);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendData(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["Z"] = (sendData);

/***/ }),

/***/ 53086:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var convertRate = function convertRate(value, exchangeRate) {
  var originExchangeRate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var numberFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var rounded = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var result = value * exchangeRate / originExchangeRate / numberFormat;
  result = rounded ? parseFloat(result).toFixed(1) : result;
  return isNaN(parseFloat(result)) ? 0 : parseFloat(result);
};

/* harmony default export */ __webpack_exports__["Z"] = (convertRate);

/***/ }),

/***/ 38951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _convertRate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53086);


var scanPrice = function scanPrice(pricing, value) {
  var exchangeRate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var originExchangeRate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var numberFormat = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var rounded = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var pricingLevel = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var tmp = 0;
  var price = 0;

  if (pricing) {
    pricing.forEach(function (v) {
      var val = (0,_convertRate__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(v.value, exchangeRate, originExchangeRate, numberFormat, rounded);

      if (parseFloat(value) > tmp && parseFloat(value) <= val) {
        if (pricingLevel) {
          price = Math.round(parseFloat((value > 0 ? v.minPrice : 0) + (0,_convertRate__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(value, 1 / exchangeRate, 1 / originExchangeRate, 1 / numberFormat, rounded) * (v.percent / 100)) / 10) * 10;
        } else {
          price = v.price;
        }
      }

      tmp = val;
    });
  }

  return price;
};

/* harmony default export */ __webpack_exports__["Z"] = (scanPrice);

/***/ }),

/***/ 7648:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var totalPrice = function totalPrice() {
  var prices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return prices.reduce(function (a, b) {
    return a + b;
  }, 0);
};

/* harmony default export */ __webpack_exports__["Z"] = (totalPrice);

/***/ }),

/***/ 62951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trigger; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function trigger(eventType, data, fullName) {
  var event = new CustomEvent(eventType, {
    detail: {
      dataForm: _objectSpread({
        fullname: fullName,
        email: data.email
      }, data),
      response: data
    }
  });

  try {
    document.dispatchEvent(event);
  } catch (error) {
    console.log(error);
  }
}

/***/ }),

/***/ 36484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckContent; }
/* harmony export */ });
/* harmony import */ var _Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59699);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function CheckContent(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "mt-2 flex items-start first:mt-0",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_0__/* .FaCheckCircle */ .F, {
        size: 16,
        className: "mr-2 mt-1 text-bbc-brand-600"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      dangerouslySetInnerHTML: {
        __html: data
      },
      className: ""
    })]
  });
}

/***/ }),

/***/ 7778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ BiLoaderAlt; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function BiLoaderAlt(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 27476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FaCheck; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaCheck(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 59699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FaCheckCircle; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaCheckCircle(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 76980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ FaInfoCircle; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaInfoCircle(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 66865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j7": function() { return /* binding */ InputEmail; },
/* harmony export */   "oH": function() { return /* binding */ InputText; },
/* harmony export */   "Z6": function() { return /* binding */ InputPhone; },
/* harmony export */   "Jg": function() { return /* binding */ CheckBox; }
/* harmony export */ });
/* unused harmony export InputNumber */
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91164);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["name", "placeholder", "register", "errors", "requiredText"],
    _excluded2 = ["as", "name", "placeholder", "register", "errors", "requiredText"],
    _excluded3 = ["name", "placeholder", "register", "errors", "requiredText", "invalidText"],
    _excluded4 = ["name", "text", "register", "errors", "checkboxTextClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var InputEmail = function InputEmail(_ref) {
  var _errors$name, _errors$email;

  var name = _ref.name,
      placeholder = _ref.placeholder,
      register = _ref.register,
      errors = _ref.errors,
      requiredText = _ref.requiredText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
      type: "email"
    }, register(name ? name : "email", {
      required: {
        value: true,
        message: requiredText || "Email is required"
      },
      pattern: {
        // Value: /(^(?:[0-9]+[a-z]|[a-z]+[0-9]|[a-z])[a-z0-9._%+-]*)+@[a-z0-9.-]+\.[a-z]{2,}$/,
        value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
        message: "Invalid e-mail"
      }
    })), {}, {
      placeholder: placeholder || "Email*",
      pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      className: "w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0 ",
      autoComplete: "off"
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-left text-sm text-red-500",
      children: name ? (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
    })]
  });
}; // Text Field must be single word or multiple word space with "_"

var InputText = function InputText(_ref2) {
  var _errors$name2;

  var as = _ref2.as,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      register = _ref2.register,
      errors = _ref2.errors,
      requiredText = _ref2.requiredText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref2, _excluded2);

  var CustomTag = as || "input";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomTag, _objectSpread(_objectSpread({
      type: "text"
    }, register(name, {
      required: {
        value: true,
        message: requiredText || "This field is required"
      }
    })), {}, {
      placeholder: placeholder,
      className: "invalid-textfield w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0",
      autoComplete: "off"
    }, props)), errors[name] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: (_errors$name2 = errors[name]) === null || _errors$name2 === void 0 ? void 0 : _errors$name2.message
    })]
  });
};
var InputPhone = function InputPhone(_ref3) {
  var _errors$name3, _errors$phone_number;

  var name = _ref3.name,
      placeholder = _ref3.placeholder,
      register = _ref3.register,
      errors = _ref3.errors,
      requiredText = _ref3.requiredText,
      invalidText = _ref3.invalidText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
      type: "text"
    }, register(name || "phone_number", {
      required: {
        value: true,
        message: requiredText || "Phone number is required"
      },
      pattern: {
        value: /[0-9]+/,
        message: invalidText || "Invalid phone number"
      }
    })), {}, {
      placeholder: placeholder,
      pattern: "[0-9]+",
      className: "invalid-textfield w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0",
      autoComplete: "off"
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: name ? (_errors$name3 = errors[name]) === null || _errors$name3 === void 0 ? void 0 : _errors$name3.message : (_errors$phone_number = errors.phone_number) === null || _errors$phone_number === void 0 ? void 0 : _errors$phone_number.message
    })]
  });
};
var InputNumber = function InputNumber(_ref4) {
  var numberValue = _ref4.numberValue,
      min = _ref4.min,
      max = _ref4.max,
      setNumberValue = _ref4.setNumberValue;

  var handleOnclickNumber = function handleOnclickNumber(number) {
    setNumberValue(number);
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "relative flex w-28 items-center lg:mb-6 lg:w-40",
      children: [/*#__PURE__*/_jsx("button", {
        className: "absolute left-2 w-5 lg:left-5 ",
        onClick: function onClick(event) {
          if (numberValue > min) {
            handleOnclickNumber(parseInt(numberValue, 10) - 1);
          }

          event.preventDefault();
        },
        children: "-"
      }), /*#__PURE__*/_jsx("button", {
        className: "absolute right-2 w-5 lg:right-5 ",
        onClick: function onClick(event) {
          if (numberValue < max) {
            handleOnclickNumber(parseInt(numberValue, 10) + 1);
          }

          event.preventDefault();
        },
        children: "+"
      }), /*#__PURE__*/_jsx("input", {
        className: "moz:appearance-none h-10 w-28 rounded-full border-zinc-200 text-center lg:w-40",
        type: "text",
        value: numberValue,
        onKeyPress: function onKeyPress(event) {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        },
        min: min,
        onChange: function onChange(event) {
          event.preventDefault();
          var newValue = event.target.value;

          if (newValue === "") {
            setNumberValue("");
          } else if (newValue < min) {
            setNumberValue(min);
          } else if (newValue > max) {
            setNumberValue(max);
          } else {
            setNumberValue(newValue);
          }
        },
        onBlur: function onBlur() {
          if (numberValue < min) {
            setNumberValue(min);
          }
        }
      })]
    })
  });
};
var CheckBox = function CheckBox(_ref5) {
  var _errors$name4;

  var name = _ref5.name,
      text = _ref5.text,
      register = _ref5.register,
      errors = _ref5.errors,
      checkboxTextClassName = _ref5.checkboxTextClassName,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref5, _excluded4);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "relative block pl-7",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
        type: "checkbox"
      }, register(name, {})), {}, {
        className: "bbc-checkbox absolute left-1 top-1 cursor-pointer rounded border-bbc-silver bg-transparent focus:shadow-none focus:outline-none focus:ring-0"
      }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: checkboxTextClassName ? checkboxTextClassName : "",
        dangerouslySetInnerHTML: {
          __html: text
        }
      })]
    }), errors[name] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: (_errors$name4 = errors[name]) === null || _errors$name4 === void 0 ? void 0 : _errors$name4.message
    })]
  });
};

/***/ }),

/***/ 78762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34853);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ReCaptcha = function ReCaptcha(props, ref) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
      ref: ref,
      sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
      badge: "inline",
      size: "invisible"
    }, props))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(ReCaptcha));

/***/ }),

/***/ 85882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Toast; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56727);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72713);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var _ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30852);
/* harmony import */ var _Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11856);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14388);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);












var contentStatus = {
  success: {
    title: "Send Success",
    description: "We'll contact you all right away."
  },
  error: {
    title: "Send Error",
    description: "Please check your network connection and try again"
  }
};
var timer = null;

var RenderContent = function RenderContent(_ref) {
  var sendStatus = _ref.sendStatus,
      sendContent = _ref.sendContent,
      setIsOpen = _ref.setIsOpen;

  switch (sendStatus) {
    case "success":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: "/assets/icons/checked.png",
              width: 90,
              height: 92,
              alt: "icon success",
              className: "mb-6"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-800",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-gray",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "error":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/error.png",
            width: 90,
            height: 92,
            alt: "icon error",
            className: "mb-6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "confirm":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/warning.png",
            width: 98,
            height: 100,
            alt: "icon error",
            className: "mx-auto mb-6",
            wrapper: {
              className: "block"
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-700",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "flex justify-around",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              variant: "outline",
              btnTextColor: "text-bbc-red-300 hover:text-white",
              btnBorder: "border border-bbc-red-300 hover:border-bbc-red-400",
              btnColor: "bg-transparent hover:bg-bbc-red-400",
              othersClass: "w-28",
              onClick: function onClick() {
                setIsOpen(false);
              },
              children: "No"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              othersClass: "w-28",
              onClick: function onClick() {
                sendContent.onClick();
                setIsOpen(false);
              },
              children: "Yes"
            })]
          })]
        });
      }

    case "custom":
      {
        return sendContent.element;
      }

    default:
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "mb-6 text-2xl font-semibold text-bbc-red-600",
          children: contentStatus.error.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-sm",
          children: contentStatus.error.description
        })]
      });
  }
};

function Toast(_ref2) {
  var children = _ref2.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendStatus = _useState2[0],
      setSendStatus = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendContent = _useState3[0],
      setSendContent = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      bgAlert = _useState4[0],
      setBgAlert = _useState4[1];
  /* Handle Event */


  var closeModal = function closeModal(otherAction) {
    setIsOpen(false);

    if (otherAction) {
      try {
        otherAction(); // eslint-disable-next-line no-empty
      } catch (error) {}
    }

    clearTimeout(timer);
    document.documentElement.removeAttribute("style");
  };

  var openAlert = /*#__PURE__*/function () {
    var _ref3 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(time, status, content, otherAction) {
      var closeModalAfterTime;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              closeModalAfterTime = function _closeModalAfterTime(timeToClose) {
                return new Promise(function (resolve) {
                  timer = setTimeout(function () {
                    closeModal(otherAction);
                    resolve("closed");
                  }, timeToClose);
                });
              };

              if (content) {
                setSendContent(content);
              } else {
                setSendContent(contentStatus[status]);
              }

              _context.t0 = status;
              _context.next = _context.t0 === "success" ? 5 : _context.t0 === "error" ? 7 : _context.t0 === "confirm" ? 9 : _context.t0 === "custom" ? 11 : 13;
              break;

            case 5:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 7:
              setBgAlert("from-[#dd3333] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 9:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 11:
              setBgAlert(sendContent.bgAlert || "from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 13:
              return _context.abrupt("break", 14);

            case 14:
              setSendStatus(status);
              setIsOpen(true);

              if (!time) {
                _context.next = 19;
                break;
              }

              _context.next = 19;
              return closeModalAfterTime(time);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openAlert(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  /* Effect */


  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(common_contexts__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext.Provider */ .uL.Provider, {
    value: {
      openAlert: openAlert,
      setOpenAlert: setIsOpen
    },
    children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition */ .uT, {
      show: isOpen,
      as: "div",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog */ .Vq, {
        open: isOpen,
        as: "div",
        className: "fixed inset-0  overflow-y-auto",
        onClose: closeModal,
        style: {
          zIndex: 100
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "fixed inset-0 bg-black/30",
          "aria-hidden": "true"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "min-h-screen px-4 text-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog.Overlay */ .Vq.Overlay, {
              className: "fixed inset-0 bg-slate-900 bg-opacity-70"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
            className: "inline-block h-screen align-middle",
            "aria-hidden": "true",
            children: "\u200B"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().ToastContent), " relative inline-flex w-full flex-col  justify-center border-2 bg-gradient-to-b px-7  py-28 text-center align-middle transition-all ").concat(bgAlert, " rounded-2xl shadow-xl"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "absolute top-6 right-4",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                  type: "button",
                  className: "inline-flex justify-center rounded-full border-2 border-white p-1 text-xs  font-medium text-white transition-all  hover:border-bbc-red-300 hover:text-bbc-red-300 focus:outline-none ",
                  onClick: closeModal,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__/* .FaTimes */ .a, {
                    size: 12
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "relative ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(RenderContent, {
                  sendContent: sendContent,
                  sendStatus: sendStatus,
                  setIsOpen: setIsOpen
                })
              })]
            })
          })]
        })]
      })
    })]
  });
}

/***/ }),

/***/ 59519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react_popper_tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49768);
/* harmony import */ var _Icon_fa_FaInfoCircle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76980);
/* harmony import */ var react_popper_tooltip_dist_styles_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23096);
/* harmony import */ var react_popper_tooltip_dist_styles_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_popper_tooltip_dist_styles_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function Tooltip(_ref) {
  var tooltipText = _ref.tooltipText;

  var _usePopperTooltip = (0,react_popper_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .usePopperTooltip */ .O)(),
      getArrowProps = _usePopperTooltip.getArrowProps,
      getTooltipProps = _usePopperTooltip.getTooltipProps,
      setTooltipRef = _usePopperTooltip.setTooltipRef,
      setTriggerRef = _usePopperTooltip.setTriggerRef,
      visible = _usePopperTooltip.visible;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", {
      type: "button",
      ref: setTriggerRef,
      className: " relative ml-2.5 mt-2 inline flex-none cursor-pointer",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Icon_fa_FaInfoCircle__WEBPACK_IMPORTED_MODULE_1__/* .FaInfoCircle */ .D, {
        className: " text-base text-bbc-neutral-600"
      })
    }), visible && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", _objectSpread(_objectSpread({
      ref: setTooltipRef
    }, getTooltipProps({
      style: {
        width: "300px"
      },
      className: "tooltip-container"
    })), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread({}, getArrowProps({
        className: "tooltip-arrow"
      }))), tooltipText]
    }))]
  });
}

/***/ }),

/***/ 88279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87536);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72713);
/* harmony import */ var common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12453);
/* harmony import */ var common_fetch_post__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92559);
/* harmony import */ var common_trigger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62951);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7778);
/* harmony import */ var components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66865);
/* harmony import */ var components_atoms_Recaptcha_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78762);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31741);
/* harmony import */ var components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85882);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













/** ========== */




var FormCountry = function FormCountry(_ref) {
  var country_id = _ref.country_id;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(common_contexts__WEBPACK_IMPORTED_MODULE_3__/* .ToastContext */ .uL),
      openAlert = _useContext.openAlert;

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      errors = _useForm$formState.errors;

  var recaptchaRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
      var token, GAUserID, dataSend;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return recaptchaRef.current.executeAsync();

            case 2:
              token = _context.sent;

              if (token) {
                GAUserID = (0,common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
                dataSend = _objectSpread({}, data);
                dataSend.client_id = GAUserID ? GAUserID : "";
                dataSend.website_id = "1";
                dataSend.company_country_id = country_id;

                try {
                  (0,common_fetch_post__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    api: "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form/question"),
                    data: dataSend,
                    token: token
                  }).then(function (res) {
                    if (res.state) {
                      (0,common_trigger__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("contact_form", dataSend, "Contact form");
                      openAlert(2000, "success");
                      reset();
                    } else {
                      openAlert(3000, "error");
                      console.log("error");
                    }
                  })["catch"](function (e) {
                    openAlert(3000, "error");
                    console.log("error", e);
                  });
                } catch (e) {
                  clearErrors();
                  openAlert(3000, "error");
                  console.log("error", e);
                }
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("form", {
    onSubmit: handleSubmit(onSubmit),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputText */ .oH, {
        register: register,
        errors: errors,
        name: "first_name",
        placeholder: "Name*",
        requiredText: "Name is required"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputEmail */ .j7, {
        register: register,
        errors: errors
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputText */ .oH, {
        as: "textarea",
        register: register,
        errors: errors,
        name: "message",
        placeholder: "Message*",
        requiredText: "Message is required"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: "flex flex-wrap items-center justify-between",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "col-12 mb-6 text-center lg:col-auto  lg:mb-0",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: "inline-block",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Recaptcha_index__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            ref: recaptchaRef,
            className: "mx-auto w-max"
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "col-12 text-center lg:col-auto",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          type: "submit",
          style: {
            minWidth: "170px"
          },
          disabled: isSubmitting,
          children: [isSubmitting && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_6__/* .BiLoaderAlt */ .s, {
            className: "mr-2 inline-block animate-spin",
            size: 20
          }), "Send Your Message"]
        })
      })]
    })]
  });
};
/** ========== */


var FormCountries = function FormCountries(_ref3) {
  var title = _ref3.title,
      description = _ref3.description,
      descriptionClass = _ref3.descriptionClass,
      contentBottom = _ref3.contentBottom,
      country_id = _ref3.country_id;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
    className: "rounded-3xl bg-white px-3  py-6 lg:px-10 lg:py-[50px]",
    style: {
      boxShadow: "0px 16px 40px rgba(181, 181, 181, 0.25)"
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      text: title,
      className: "mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800 lg:mb-10 lg:text-center lg:text-bbc-40px"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
      className: "".concat(descriptionClass ? descriptionClass : "mb-6 text-center lg:mb-10"),
      children: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FormCountry, {
        country_id: country_id
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      children: contentBottom
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FormCountries);
FormCountries.defaultProps = {
  title: "",
  description: "",
  nameProps: {},
  emailProps: {},
  messageProps: {}
};
/** ========== */

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 18695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ AccountingAndTaxation; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaCheck.js
var FaCheck = __webpack_require__(27476);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FormCountries/index.js
var FormCountries = __webpack_require__(88279);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.js
var fa = __webpack_require__(85809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/source-function/convertRate.js
var convertRate = __webpack_require__(53086);
// EXTERNAL MODULE: ./common/source-function/numberFormat.js
var numberFormat = __webpack_require__(80077);
// EXTERNAL MODULE: ./common/source-function/scanPrice.js
var scanPrice = __webpack_require__(38951);
// EXTERNAL MODULE: ./common/source-function/totalPrice.js
var totalPrice = __webpack_require__(7648);
// EXTERNAL MODULE: ./components/atoms/CheckContent/index.js
var CheckContent = __webpack_require__(36484);
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
// EXTERNAL MODULE: ./components/atoms/Tooltip/index.js
var Tooltip = __webpack_require__(59519);
// EXTERNAL MODULE: ./components/organisms/AccountingAuditing/ServiceFeeCalculator/Index.module.scss
var Index_module = __webpack_require__(36913);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/AccountingAuditing/ServiceFeeCalculator/AccountingTab.js








var AccountingTab = function AccountingTab(_ref) {
  var accountingService = _ref.accountingService,
      setAccountingValue = _ref.setAccountingValue,
      accountingValue = _ref.accountingValue,
      xero = _ref.xero,
      setXero = _ref.setXero;
  var transaction = (accountingService === null || accountingService === void 0 ? void 0 : accountingService.transaction) || {};
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 flex items-center justify-center gap-x-7",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        className: "h-8 w-20 rounded-full border border-bbc-neutral-600 text-center outline-none",
        value: (0,numberFormat/* default */.Z)(accountingValue),
        onChange: function onChange(e) {
          return setAccountingValue(e.target.value);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Transactions per month"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:px-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        className: "form-input mb-4 h-1 w-full appearance-none rounded-full bg-bbc-primary focus:shadow-none focus:outline-0 focus:ring-0 ".concat((Index_module_default()).sfc_slider),
        min: transaction.min || 1,
        max: transaction.max || 1000,
        step: transaction.step || 1,
        value: accountingValue,
        onChange: function onChange(e) {
          return setAccountingValue(e.target.value);
        },
        type: "range"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-8 flex justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (0,numberFormat/* default */.Z)(transaction.min || 1)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: (0,numberFormat/* default */.Z)(transaction.max || 1000)
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-8 flex  flex-row items-center gap-y-3",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: "multi-currency",
            type: "checkbox",
            className: "bbc-checkbox form-input cursor-pointer rounded-full border outline-none ring-0 focus:outline-0 focus:ring-0",
            checked: xero.checked,
            onChange: function onChange(e) {
              return setXero(e.target.checked);
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          htmlFor: "multi-currency",
          className: "mr-2 cursor-pointer select-none pl-1.5",
          children: ["Multi-currency Xero accounting", " ", "".concat(accountingService === null || accountingService === void 0 ? void 0 : accountingService.currencySymbol).concat(xero.value), "/month"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
          tooltipText: "If your business's revenue or expense arises in 2 currencies or above, Xero multiple-currency account would be needed for foreign currency translation. The fee is fixed at USD 25/ month no matter how many foreign currencies you have."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-8 border-t border-neutral-600 border-opacity-40"
      })]
    })]
  });
};

/* harmony default export */ var ServiceFeeCalculator_AccountingTab = (AccountingTab);
AccountingTab.defaultProps = {
  accountingService: {},
  setAccountingValue: function setAccountingValue() {},
  accountingValue: "",
  xero: {},
  setXero: function setXero() {}
};
;// CONCATENATED MODULE: ./components/organisms/AccountingAuditing/ServiceFeeCalculator/AuditingTab.js






var AuditingTab = function AuditingTab(_ref) {
  var _auditingType$format, _auditingType$format2, _auditingType$format3, _auditingType$format4, _auditingType$format5, _auditingType$revenue, _auditingType$format6, _auditingType$format7;

  var setAuditingIndexType = _ref.setAuditingIndexType,
      revenue = _ref.revenue,
      revenueMin = _ref.revenueMin,
      revenueMax = _ref.revenueMax,
      auditingIndexType = _ref.auditingIndexType,
      auditingService = _ref.auditingService,
      setRevenue = _ref.setRevenue;
  var auditingType = auditingService === null || auditingService === void 0 ? void 0 : auditingService.types[auditingIndexType];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mb-6 flex flex-wrap items-center justify-center gap-x-1 gap-y-2 pl-3",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "whitespace-nowrap",
        children: "Up to"
      }), auditingIndexType === 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        id: "upto-input",
        className: "h-8 rounded-full border border-bbc-neutral-600 text-center outline-none ".concat((Index_module_default()).inputNumber, " ").concat(auditingType !== null && auditingType !== void 0 && (_auditingType$format = auditingType.format) !== null && _auditingType$format !== void 0 && _auditingType$format.unit && (auditingType === null || auditingType === void 0 ? void 0 : (_auditingType$format2 = auditingType.format) === null || _auditingType$format2 === void 0 ? void 0 : _auditingType$format2.unit) !== "" ? "w-20" : "w-32"),
        type: "number",
        value: revenue,
        onChange: function onChange(e) {
          if (e.target.value.length === 2 && (e.target.value[1] != "." || e.target.value[1] != ",") && e.target.value[0] == 0) {
            document.getElementById("upto-input").value = parseFloat(e.target.value);
          }

          setRevenue(e.target.value);
        }
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        className: "h-8 rounded-full border border-bbc-neutral-600 text-center outline-none ".concat((Index_module_default()).inputNumber, " ").concat(auditingType !== null && auditingType !== void 0 && (_auditingType$format3 = auditingType.format) !== null && _auditingType$format3 !== void 0 && _auditingType$format3.unit && (auditingType === null || auditingType === void 0 ? void 0 : (_auditingType$format4 = auditingType.format) === null || _auditingType$format4 === void 0 ? void 0 : _auditingType$format4.unit) !== "" ? "w-20" : "w-32"),
        type: "text",
        value: (0,numberFormat/* default */.Z)(revenue),
        onChange: function onChange(e) {
          setRevenue(e.target.value);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: auditingType === null || auditingType === void 0 ? void 0 : (_auditingType$format5 = auditingType.format) === null || _auditingType$format5 === void 0 ? void 0 : _auditingType$format5.unit
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("select", {
        value: "".concat(auditingIndexType),
        onChange: function onChange(e) {
          return setAuditingIndexType(parseInt(e.target.value, 10));
        },
        className: "h-8 w-20 rounded-full border border-bbc-neutral-600 py-0 pr-7 outline-none",
        children: auditingService === null || auditingService === void 0 ? void 0 : auditingService.types.map(function (value, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
            value: index,
            children: value.name
          }, index);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "whitespace-nowrap",
        children: "Annual revenue"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:px-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        className: "form-input mb-4 h-1 w-full appearance-none rounded-full bg-bbc-primary focus:shadow-none focus:outline-0 focus:ring-0 ".concat((Index_module_default()).sfc_slider),
        type: "range",
        min: revenueMin,
        max: revenueMax,
        step: (auditingType === null || auditingType === void 0 ? void 0 : (_auditingType$revenue = auditingType.revenue) === null || _auditingType$revenue === void 0 ? void 0 : _auditingType$revenue.step) || 1,
        value: revenue,
        onChange: function onChange(e) {
          return setRevenue(e.target.value);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-8 flex justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: [(0,numberFormat/* default */.Z)(revenueMin), " ", (auditingType === null || auditingType === void 0 ? void 0 : (_auditingType$format6 = auditingType.format) === null || _auditingType$format6 === void 0 ? void 0 : _auditingType$format6.unit) || ""]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: [" ", auditingType !== null && auditingType !== void 0 && auditingType.rounded ? parseFloat((0,numberFormat/* default */.Z)(revenueMax)).toFixed(2) : (0,numberFormat/* default */.Z)(revenueMax), " ", (auditingType === null || auditingType === void 0 ? void 0 : (_auditingType$format7 = auditingType.format) === null || _auditingType$format7 === void 0 ? void 0 : _auditingType$format7.unit) || ""]
        })]
      })]
    })]
  });
};

/* harmony default export */ var ServiceFeeCalculator_AuditingTab = (AuditingTab);
AuditingTab.defaultProps = {
  setAuditingIndexType: function setAuditingIndexType() {},
  revenue: 0,
  revenueMin: 0,
  revenueMax: 0,
  auditingIndexType: 0,
  auditingService: {},
  setRevenue: function setRevenue() {}
};
;// CONCATENATED MODULE: ./components/organisms/AccountingAuditing/ServiceFeeCalculator/index.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













/* ********** */




var tabs = [{
  id: 1,
  name: "Accounting"
}, {
  id: 2,
  name: "Auditing"
}];
var initState = {
  tabIndex: 0,
  paymentType: "yearly",
  accountingValue: 1
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "fee_update_state":
      return _objectSpread(_objectSpread({}, state), action.payload);

    default:
      return state;
  }
};

var ServiceFeeCalculator = function ServiceFeeCalculator(_ref) {
  var _services$, _services$$revenue, _services$2, _services$2$types$, _services$3, _services$4, _services$4$types$, _services$4$types$$fo, _services$5, _services$5$revenue, _services$6, _services$6$types$, _services$7, _services$8, _services$8$types$, _services$8$types$$fo, _services$9, _services$9$revenue, _services$10, _services$10$types$, _services$11, _services$12, _services$12$types$, _services$12$types$$f, _services$13, _services$14, _services$14$xero, _state$accountingServ2, _state$accountingServ3, _state$accountingServ4, _state$accountingServ5, _state$auditingServic, _state$auditingServic2, _state$auditingServic3, _state$auditingServic4, _state$auditingServic5, _state$auditingServic6, _state$auditingServic7, _state$auditingServic8, _state$auditingServic9, _state$auditingServic10, _services$state$tabIn, _services$state$tabIn2, _services$state$tabIn3, _services$state$tabIn4, _state$accountingServ6, _services$state$tabIn5, _state$accountingServ7, _state$accountingServ8, _state$accountingServ9, _state$auditingServic11, _state$auditingServic12, _state$auditingServic13, _state$auditingServic14, _state$auditingServic15, _state$auditingServic16, _state$auditingServic17, _state$auditingServic18, _state$auditingServic19, _state$auditingServic20;

  var services = _ref.services;

  var priceAccountingPerMonth = function priceAccountingPerMonth(pricing, transaction) {
    var xero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var month = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var price = (0,scanPrice/* default */.Z)(pricing, transaction);
    return (parseFloat(price) + parseFloat(xero)) * month;
  };

  var priceAuditing = function priceAuditing(pricing, revenue) {
    var exchangeRate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var originExchangeRate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var numberFormat = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var rounded = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var pricingLevel = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    return parseFloat((0,scanPrice/* default */.Z)(pricing, revenue, exchangeRate, originExchangeRate, numberFormat, rounded, pricingLevel));
  };

  var _useReducer = (0,react.useReducer)(reducer, _objectSpread(_objectSpread({}, initState), {}, {
    accountingService: services[0],
    auditingService: services[1],
    auditingIndexType: 0,
    revenueMin: (0,convertRate/* default */.Z)((_services$ = services[1]) === null || _services$ === void 0 ? void 0 : (_services$$revenue = _services$.revenue) === null || _services$$revenue === void 0 ? void 0 : _services$$revenue.min, (_services$2 = services[1]) === null || _services$2 === void 0 ? void 0 : (_services$2$types$ = _services$2.types[0]) === null || _services$2$types$ === void 0 ? void 0 : _services$2$types$.exchangeRate, (_services$3 = services[1]) === null || _services$3 === void 0 ? void 0 : _services$3.exchangeRate, (_services$4 = services[1]) === null || _services$4 === void 0 ? void 0 : (_services$4$types$ = _services$4.types[0]) === null || _services$4$types$ === void 0 ? void 0 : (_services$4$types$$fo = _services$4$types$.format) === null || _services$4$types$$fo === void 0 ? void 0 : _services$4$types$$fo.value),
    revenueMax: (0,convertRate/* default */.Z)((_services$5 = services[1]) === null || _services$5 === void 0 ? void 0 : (_services$5$revenue = _services$5.revenue) === null || _services$5$revenue === void 0 ? void 0 : _services$5$revenue.max, (_services$6 = services[1]) === null || _services$6 === void 0 ? void 0 : (_services$6$types$ = _services$6.types[0]) === null || _services$6$types$ === void 0 ? void 0 : _services$6$types$.exchangeRate, (_services$7 = services[1]) === null || _services$7 === void 0 ? void 0 : _services$7.exchangeRate, (_services$8 = services[1]) === null || _services$8 === void 0 ? void 0 : (_services$8$types$ = _services$8.types[0]) === null || _services$8$types$ === void 0 ? void 0 : (_services$8$types$$fo = _services$8$types$.format) === null || _services$8$types$$fo === void 0 ? void 0 : _services$8$types$$fo.value),
    revenue: (0,convertRate/* default */.Z)((_services$9 = services[1]) === null || _services$9 === void 0 ? void 0 : (_services$9$revenue = _services$9.revenue) === null || _services$9$revenue === void 0 ? void 0 : _services$9$revenue.min, (_services$10 = services[1]) === null || _services$10 === void 0 ? void 0 : (_services$10$types$ = _services$10.types[0]) === null || _services$10$types$ === void 0 ? void 0 : _services$10$types$.exchangeRate, (_services$11 = services[1]) === null || _services$11 === void 0 ? void 0 : _services$11.exchangeRate, (_services$12 = services[1]) === null || _services$12 === void 0 ? void 0 : (_services$12$types$ = _services$12.types[0]) === null || _services$12$types$ === void 0 ? void 0 : (_services$12$types$$f = _services$12$types$.format) === null || _services$12$types$$f === void 0 ? void 0 : _services$12$types$$f.value),
    xero: _objectSpread(_objectSpread({}, (_services$13 = services[0]) === null || _services$13 === void 0 ? void 0 : _services$13.xero), {}, {
      checked: (_services$14 = services[0]) === null || _services$14 === void 0 ? void 0 : (_services$14$xero = _services$14.xero) === null || _services$14$xero === void 0 ? void 0 : _services$14$xero["default"]
    })
  })),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var updateState = function updateState(payload) {
    dispatch({
      type: "fee_update_state",
      payload: payload
    });
  };

  var setTabIndex = function setTabIndex(index) {
    updateState({
      tabIndex: index
    });
  };

  var setPaymentType = function setPaymentType(type) {
    updateState({
      paymentType: type
    });
  };

  var setAuditingIndexType = function setAuditingIndexType(newAuditingIndexType) {
    var _auditingService$reve, _auditingType$format, _auditingService$reve2, _auditingType$format2, _auditingService$reve3, _auditingType$format3;

    var auditingService = state.auditingService;
    var auditingType = auditingService === null || auditingService === void 0 ? void 0 : auditingService.types[newAuditingIndexType];
    updateState({
      auditingIndexType: newAuditingIndexType,
      revenueMin: (0,convertRate/* default */.Z)(auditingService === null || auditingService === void 0 ? void 0 : (_auditingService$reve = auditingService.revenue) === null || _auditingService$reve === void 0 ? void 0 : _auditingService$reve.min, auditingType === null || auditingType === void 0 ? void 0 : auditingType.exchangeRate, auditingService === null || auditingService === void 0 ? void 0 : auditingService.exchangeRate, auditingType === null || auditingType === void 0 ? void 0 : (_auditingType$format = auditingType.format) === null || _auditingType$format === void 0 ? void 0 : _auditingType$format.value),
      revenueMax: (0,convertRate/* default */.Z)(auditingService === null || auditingService === void 0 ? void 0 : (_auditingService$reve2 = auditingService.revenue) === null || _auditingService$reve2 === void 0 ? void 0 : _auditingService$reve2.max, auditingType === null || auditingType === void 0 ? void 0 : auditingType.exchangeRate, auditingService === null || auditingService === void 0 ? void 0 : auditingService.exchangeRate, auditingType === null || auditingType === void 0 ? void 0 : (_auditingType$format2 = auditingType.format) === null || _auditingType$format2 === void 0 ? void 0 : _auditingType$format2.value),
      revenue: (0,convertRate/* default */.Z)(auditingService === null || auditingService === void 0 ? void 0 : (_auditingService$reve3 = auditingService.revenue) === null || _auditingService$reve3 === void 0 ? void 0 : _auditingService$reve3.min, auditingType === null || auditingType === void 0 ? void 0 : auditingType.exchangeRate, auditingService === null || auditingService === void 0 ? void 0 : auditingService.exchangeRate, auditingType === null || auditingType === void 0 ? void 0 : (_auditingType$format3 = auditingType.format) === null || _auditingType$format3 === void 0 ? void 0 : _auditingType$format3.value)
    });
  };

  var setRevenue = function setRevenue(value) {
    var valueTemp = value === "" ? "".concat(state.revenueMin) : value.replaceAll(",", "");
    var valueNum = parseFloat(valueTemp);

    if (!isNaN(valueNum)) {
      if (valueNum > state.revenueMax) {
        valueNum = state.revenueMax;
      }

      if (valueNum < state.revenueMin) {
        valueNum = state.revenueMin;
      }

      updateState({
        revenue: valueNum
      });
    }
  };

  var setXero = function setXero(checked) {
    updateState({
      xero: _objectSpread(_objectSpread({}, state.xero), {}, {
        checked: checked
      })
    });
  };

  var setAccountingValue = function setAccountingValue(value) {
    var _state$accountingServ;

    var valueTemp = value === "" ? "" : "".concat(value.replaceAll(",", ""));
    var accType = (_state$accountingServ = state.accountingService) === null || _state$accountingServ === void 0 ? void 0 : _state$accountingServ.types.find(function (item) {
      return item.key === state.paymentType;
    });
    var accountingTemp = parseFloat(valueTemp);

    if (!Number.isNaN(accountingTemp) && accType) {
      var _accType$transaction, _accType$transaction2;

      if (accountingTemp >= ((_accType$transaction = accType.transaction) === null || _accType$transaction === void 0 ? void 0 : _accType$transaction.min) && accountingTemp <= ((_accType$transaction2 = accType.transaction) === null || _accType$transaction2 === void 0 ? void 0 : _accType$transaction2.max)) {
        updateState({
          accountingValue: accountingTemp
        });
      }
    } else if (value === "") {
      updateState({
        accountingValue: ""
      });
    }
  };

  (0,react.useEffect)(function () {
    var accAudit = document.getElementById("accounting-auditing");

    if (accAudit) {
      var _ret = function () {
        var tabs = document.querySelectorAll('[role="tab"]');

        var handle = function handle(index) {
          setTabIndex(index);
        };

        var _loop = function _loop(i) {
          tabs[i].addEventListener("click", function () {
            return handle(i);
          });
        };

        for (var i = 0; i < tabs.length; i++) {
          _loop(i);
        }

        return {
          v: function v() {
            var _loop2 = function _loop2(_i) {
              tabs[_i].removeEventListener("click", function () {
                return handle(_i);
              });
            };

            for (var _i = 0; _i < tabs.length; _i++) {
              _loop2(_i);
            }
          }
        };
      }();

      if (typeof _ret === "object") return _ret.v;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  (0,react.useEffect)(function () {
    var hash = window.location.hash;

    if ((hash === null || hash === void 0 ? void 0 : hash.length) > 0) {
      var scrollToTable = document.getElementById("accounting-auditing");
      window.scrollTo({
        top: scrollToTable.offsetTop - 160,
        behavior: "smooth"
      });
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "accounting-auditing",
    className: "lg:shadow-bbc rounded-3xl lg:bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "row",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-12 lg:col-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "pt-3 pb-7 lg:py-9",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
            data: tabs.map(function (item) {
              return item.name;
            }),
            tabListClass: {
              padding: "p-1"
            },
            tabClass: {
              padding: "px-4 py-1",
              tabColorActive: "text-white bg-bbc-brand-500"
            },
            activeTab: 0
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "pt-10 lg:pt-8",
            children: [state.tabIndex === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFeeCalculator_AccountingTab, {
              setAccountingValue: setAccountingValue,
              accountingValue: state.accountingValue,
              accountingService: state.accountingService,
              xero: state.xero,
              setXero: setXero
            }), state.tabIndex === 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFeeCalculator_AuditingTab, {
              revenueMin: state.revenueMin,
              revenueMax: state.revenueMax,
              revenue: state.revenue,
              setAuditingIndexType: setAuditingIndexType,
              auditingIndexType: state.auditingIndexType,
              auditingService: state.auditingService,
              setRevenue: setRevenue
            }), state.tabIndex === 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col items-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mb-4 text-center text-2xl font-semibold lg:text-lg",
                children: "What included in Accounting packages"
              }), state.paymentType === "monthly" && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: "w-full lg:w-auto",
                children: state.accountingService.types[0].content.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-1 flex items-center gap-3",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckContent/* default */.Z, {
                      data: item
                    })
                  }, index);
                })
              }), state.paymentType === "yearly" && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: "w-full lg:w-auto",
                children: state.accountingService.types[1].content.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    className: "mb-1 flex items-center gap-3",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CheckContent/* default */.Z, {
                      data: item
                    })
                  }, index);
                })
              })]
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-12 lg:col-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "h-full rounded-3xl bg-bbc-gradient-3 py-8 px-6 lg:py-12 lg:px-11",
          children: [state.tabIndex === 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mb-8 flex items-center justify-center gap-x-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-white",
              children: "Monthly"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Switch */.rs, {
              checked: state.paymentType === "yearly",
              onChange: function onChange(value) {
                return setPaymentType(value ? "yearly" : "monthly");
              },
              className: "relative  inline-flex  cursor-pointer rounded-full border-transparent bg-white ".concat((Index_module_default())["switch"]),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                "aria-hidden": "true",
                className: "".concat(state.paymentType === "yearly" ? "translate-x-9" : "translate-x-0", " ").concat((Index_module_default()).paymentType, " inline-block rounded-full bg-bbc-primary  transition duration-200 ease-in-out")
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-white",
              children: "Yearly"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mb-8 flex items-end justify-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: "text-5xl font-semibold text-white",
              children: [state.tabIndex === 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [(_state$accountingServ2 = state.accountingService) === null || _state$accountingServ2 === void 0 ? void 0 : _state$accountingServ2.currencySymbol, (0,numberFormat/* default */.Z)(priceAccountingPerMonth((_state$accountingServ3 = state.accountingService) === null || _state$accountingServ3 === void 0 ? void 0 : (_state$accountingServ4 = _state$accountingServ3.types.find(function (item) {
                  return item.key === state.paymentType;
                })) === null || _state$accountingServ4 === void 0 ? void 0 : _state$accountingServ4.pricing, state.accountingValue, state.xero.checked ? state.xero.value : 0))]
              }), state.tabIndex === 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [(_state$accountingServ5 = state.accountingService) === null || _state$accountingServ5 === void 0 ? void 0 : _state$accountingServ5.currencySymbol, (0,numberFormat/* default */.Z)(priceAuditing((_state$auditingServic = state.auditingService) === null || _state$auditingServic === void 0 ? void 0 : _state$auditingServic.pricing, state.revenue, (_state$auditingServic2 = state.auditingService) === null || _state$auditingServic2 === void 0 ? void 0 : (_state$auditingServic3 = _state$auditingServic2.types[state.auditingIndexType]) === null || _state$auditingServic3 === void 0 ? void 0 : _state$auditingServic3.exchangeRate, (_state$auditingServic4 = state.auditingService) === null || _state$auditingServic4 === void 0 ? void 0 : _state$auditingServic4.exchangeRate, (_state$auditingServic5 = state.auditingService) === null || _state$auditingServic5 === void 0 ? void 0 : (_state$auditingServic6 = _state$auditingServic5.types[state.auditingIndexType]) === null || _state$auditingServic6 === void 0 ? void 0 : (_state$auditingServic7 = _state$auditingServic6.format) === null || _state$auditingServic7 === void 0 ? void 0 : _state$auditingServic7.value, (_state$auditingServic8 = state.auditingService) === null || _state$auditingServic8 === void 0 ? void 0 : (_state$auditingServic9 = _state$auditingServic8.types[state.auditingIndexType]) === null || _state$auditingServic9 === void 0 ? void 0 : _state$auditingServic9.rounded, (_state$auditingServic10 = state.auditingService) === null || _state$auditingServic10 === void 0 ? void 0 : _state$auditingServic10.pricingLevel))]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-lg font-semibold text-white",
              children: state.tabIndex === 0 ? "/Month" : ""
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "mb-1 text-center text-white",
            children: ["Total yearly estimated cost for", " ", (_services$state$tabIn = services[state.tabIndex]) !== null && _services$state$tabIn !== void 0 && (_services$state$tabIn2 = _services$state$tabIn.types[state.auditingIndexType]) !== null && _services$state$tabIn2 !== void 0 && _services$state$tabIn2.costFor ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: state.revenue > 0 ? (_services$state$tabIn3 = services[state.tabIndex]) === null || _services$state$tabIn3 === void 0 ? void 0 : (_services$state$tabIn4 = _services$state$tabIn3.types[state.auditingIndexType]) === null || _services$state$tabIn4 === void 0 ? void 0 : _services$state$tabIn4.costFor : (_state$accountingServ6 = state.accountingService) === null || _state$accountingServ6 === void 0 ? void 0 : _state$accountingServ6.name
            }) : (_services$state$tabIn5 = services[state.tabIndex]) === null || _services$state$tabIn5 === void 0 ? void 0 : _services$state$tabIn5.name, ":"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "mb-8 text-center text-lg font-semibold text-white",
            children: [(_state$accountingServ7 = state.accountingService) === null || _state$accountingServ7 === void 0 ? void 0 : _state$accountingServ7.currencySymbol, (0,numberFormat/* default */.Z)((0,totalPrice/* default */.Z)([priceAccountingPerMonth((_state$accountingServ8 = state.accountingService) === null || _state$accountingServ8 === void 0 ? void 0 : (_state$accountingServ9 = _state$accountingServ8.types.find(function (item) {
              return item.key === state.paymentType;
            })) === null || _state$accountingServ9 === void 0 ? void 0 : _state$accountingServ9.pricing, state.accountingValue, state.xero.checked ? state.xero.value : 0, 12), priceAuditing((_state$auditingServic11 = state.auditingService) === null || _state$auditingServic11 === void 0 ? void 0 : _state$auditingServic11.pricing, state.revenue, (_state$auditingServic12 = state.auditingService) === null || _state$auditingServic12 === void 0 ? void 0 : (_state$auditingServic13 = _state$auditingServic12.types[state.auditingIndexType]) === null || _state$auditingServic13 === void 0 ? void 0 : _state$auditingServic13.exchangeRate, (_state$auditingServic14 = state.auditingService) === null || _state$auditingServic14 === void 0 ? void 0 : _state$auditingServic14.exchangeRate, (_state$auditingServic15 = state.auditingService) === null || _state$auditingServic15 === void 0 ? void 0 : (_state$auditingServic16 = _state$auditingServic15.types[state.auditingIndexType]) === null || _state$auditingServic16 === void 0 ? void 0 : (_state$auditingServic17 = _state$auditingServic16.format) === null || _state$auditingServic17 === void 0 ? void 0 : _state$auditingServic17.value, (_state$auditingServic18 = state.auditingService) === null || _state$auditingServic18 === void 0 ? void 0 : (_state$auditingServic19 = _state$auditingServic18.types[state.auditingIndexType]) === null || _state$auditingServic19 === void 0 ? void 0 : _state$auditingServic19.rounded, (_state$auditingServic20 = state.auditingService) === null || _state$auditingServic20 === void 0 ? void 0 : _state$auditingServic20.pricingLevel)]))]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mb-8 flex justify-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
              btnTextColor: "text-bbc-brand-500",
              btnColor: "bg-white",
              onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return Tawk_API.toggle();

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })),
              children: "Talk To Us"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "text-center text-white",
            children: ["** The above fee is in USD and may vary depending on the complexity", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "of your transaction"]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var AccountingAuditing_ServiceFeeCalculator = (ServiceFeeCalculator);
ServiceFeeCalculator.defaultProps = {
  services: []
};
;// CONCATENATED MODULE: ./components/organisms/AccountingAuditing/index.js



/* ********** */




var AccountingAuditing = function AccountingAuditing(_ref) {
  var services = _ref.services;
  // ******
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "container",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "row justify-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "col-12 lg:col-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "Accounting and Auditing",
          className: "title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-4",
          children: "Our accounting and auditing service covers the following areas to keep you stay compliance with reporting obligations:"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "mb-4 flex items-center gap-3",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(fa/* FaCheck */.l_A, {
                className: "text-bbc-brand-500 ",
                size: 12
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Preparing annual statutory accounts i.e Profit & Loss account, Balance Sheet, Trial Balance..."
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "mb-4 flex items-center gap-3",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(fa/* FaCheck */.l_A, {
                className: "text-bbc-brand-500 ",
                size: 12
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Audited financial statements"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-9 lg:mb-10",
          children: "We charge fees for services depending on the quantity and complexity of your transactions."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AccountingAuditing_ServiceFeeCalculator, {
          services: services
        })]
      })
    })
  });
};

/* harmony default export */ var organisms_AccountingAuditing = (AccountingAuditing);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
;// CONCATENATED MODULE: ./components/templates/hk/accounting-and-auditing/index.js












var AccountingService = function AccountingService(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex h-full flex-col items-center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-4 inline-flex h-20 w-20 items-center justify-center rounded-xl bg-white",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: item.image,
        width: 48,
        height: 48,
        alt: item.name,
        wrapper: {
          className: "block"
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "text-center text-lg text-white",
      dangerouslySetInnerHTML: {
        __html: item.name
      }
    })]
  });
};

var TaxServiceCard = function TaxServiceCard(_ref2) {
  var item = _ref2.item;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "lg:shadow-bbc flex h-full flex-col justify-between overflow-hidden rounded-3xl border bg-white px-8 pt-9 shadow-none lg:border-0 lg:px-0",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex justify-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6 inline-flex h-20 w-20 items-center justify-center rounded-3xl bg-bbc-brand-100",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: item.image,
          width: 38,
          height: 48,
          alt: item.name
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "mb-4 flex-grow text-center lg:px-3",
      dangerouslySetInnerHTML: {
        __html: item.content
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "border-t py-4 lg:px-3",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-center text-5xl font-semibold text-bbc-yellow-500",
        children: item.price
      })
    })]
  });
};

var DocumentCard = function DocumentCard(_ref3) {
  var item = _ref3.item;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "lg:shadow-bbc flex h-full flex-col justify-between overflow-hidden rounded-3xl border bg-white pt-9 shadow-none lg:border-0",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex justify-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6 inline-flex h-20 w-20 items-center justify-center rounded-3xl bg-bbc-brand-100",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: item.image,
          width: 38,
          height: 48,
          alt: item.name
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex-grow border-t px-7 pb-4 pt-2",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-center",
        dangerouslySetInnerHTML: {
          __html: item.name
        }
      })
    })]
  });
};

var AccountingAndAuditing = function AccountingAndAuditing(_ref4) {
  var data = _ref4.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        minHeightBanner: "banner-min-h-635",
        title: "Accounting,<br/>Auditing & Tax Filing <br/>in Hong Kong",
        bgColor: "bg-bbc-gradient-service",
        breadcrumbs: [{
          title: "Home",
          uri: "/"
        }, {
          title: "Accounting, Auditing & Tax Filing",
          uri: "#"
        }],
        leftClassName: " lg:col-6",
        rightClassName: " lg:col-6",
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/hk/accounting-auditing/banner-accountinga-and-auditing.png",
          width: 553,
          height: 488,
          alt: "Hong Kong accounting service",
          className: "h-full w-full",
          wrapper: {
            className: "bbc-banner-image-country xl:top-24 pb-10 lg:pb-0"
          },
          priority: true
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row lg:flex-row-reverse",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 flex justify-center lg:col-5",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/hk/accounting-auditing/requirements-hk-accounting.png",
              width: 445,
              height: 456,
              alt: "accounting requirements in Hong Kong"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 lg:col-7 lg:pr-10",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "pb-4",
              children: "Under Hong Kong Inland Revenue Ordinance and Companies Ordinance, Hong Kong-registered companies are required to prepare and maintain financial records and hire a local qualified accounting firm to perform audit tasks on financial statements."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "pb-4",
              children: "Special notes for Hong Kong Company accounting and auditing:"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: "leading-bbc-26",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mb-4",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "Hong Kong company must maintain accounting records for at least 7 years since the end of the financial year."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                className: "relative mb-4",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                  className: "absolute top-1.5 left-0 text-bbc-brand-500",
                  size: 12
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7",
                  children: "All Hong Kong companies must carry out an audit on their annual financial statements, except for dormant companies."
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "BBCIncorp Limited offers qualified Hong Kong accounting services for your business! Our team of experienced Certified Public Accountants will help you relieve from reporting burden and have more time to concentrate on your business. Effective communication and seamless integration will make us your great companion."
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "bg-bbc-gradient-2",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container relative py-10 lg:py-20",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 mb-10 text-center font-semibold text-bbc-white lg:mb-10",
          children: "Hong Kong Accounting Services with BBCIncorp"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: " col-10 m-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "row gap-y-16",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 md:col-6 lg:col-3",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccountingService, {
                item: {
                  image: "/assets/images/hk/accounting-auditing/cloud_accounting-hk-accounting.svg",
                  name: "Cloud accounting"
                }
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 flex flex-col items-center md:col-6 lg:col-3",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccountingService, {
                item: {
                  image: "/assets/images/hk/accounting-auditing/affortable-hk-accounting.svg",
                  name: "Affordable &<br /> transparent pricing"
                }
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 flex flex-col items-center md:col-6 lg:col-3",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccountingService, {
                item: {
                  image: "/assets/images/hk/accounting-auditing/communication-hk-accounting.svg",
                  name: "Effective <br /> communication"
                }
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "col-12 flex flex-col items-center md:col-6 lg:col-3",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccountingService, {
                item: {
                  image: "/assets/images/hk/accounting-auditing/certificated-hk-accounting.svg",
                  name: "CPA certified <br /> experts"
                }
              })
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_AccountingAuditing, {
        services: data.serviceFees
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "m-auto lg:col-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            text: "Tax Filing Services",
            className: "title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "mb-10",
            children: ["Hong Kong tax year or year of assessment begins from 1st April to 31st March in the next year. A company is liable for its first tax return filing around 18 months from the incorporation date and every financial year end subsequently. Business owners should be aware of tax filing obligations to avoid heavy penalties by Hong Kong Tax Authority.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Our experienced accountants will cover your back with tax planning and consultation. We also help you with offshore tax claim applications for income derived outside Hong Kong.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Below is the pricing for our corporate tax filing service."]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row mb-8 justify-center gap-y-8 md:mb-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 md:col-5 lg:col-4 xl:col-3",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TaxServiceCard, {
              item: {
                name: "tax computation",
                image: "/assets/images/hk/accounting-auditing/tax_computation-hk-accounting.svg",
                content: "Filing Profits Tax Return and tax computation with supporting schedules",
                price: "$100"
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 md:col-5 lg:col-4 xl:col-3",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TaxServiceCard, {
              item: {
                name: "Filing",
                image: "/assets/images/hk/accounting-auditing/filling-hk-accounting.svg",
                content: "Filing Employer’s Return<br />(NIL)",
                price: "$100"
              }
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
            as: "a",
            useRouter: true,
            href: "/contact-us",
            children: "Start Experiencing Our Service"
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "relative bg-bbc-gradient-liner",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/hk/accounting-auditing/bg_verblue-hk-accounting.png",
        width: 375,
        height: 928,
        className: "absolute left-0 top-0 h-full w-full md:hidden",
        alt: "bg blue"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/hk/accounting-auditing/bg_blue-hk-accounting.png",
        width: 1920,
        height: 420,
        className: "absolute left-0 top-0 hidden h-full w-full md:block",
        alt: "bg blue"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container relative py-10 lg:py-20",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "Documents Required",
          className: "mb-6 text-center text-3xl font-semibold text-white lg:mb-10 lg:text-bbc-40px"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row justify-center gap-8",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 px-11  md:px-0 lg:col-3",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DocumentCard, {
              item: {
                name: "All invoices in the<br/>reporting period",
                image: "/assets/images/hk/accounting-auditing/invoice-hk-accounting.svg"
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 px-11  md:px-0 lg:col-3",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DocumentCard, {
              item: {
                name: "Company bank<br/>statements",
                image: "/assets/images/hk/accounting-auditing/tax_computation-hk-accounting.svg"
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 px-11  md:px-0 lg:col-3",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DocumentCard, {
              item: {
                name: "Company incorporation<br/>documents",
                image: "/assets/images/hk/accounting-auditing/filling-hk-accounting.svg"
              }
            })
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "m-auto lg:col-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormCountries/* default */.Z, {
            title: "Need more help with your Hong Kong accounting plan?",
            descriptionClass: "mb-6 lg:mb-10 text-center",
            description: "Just get in touch with us. We typically respond within 2 hrs.",
            nameProps: {
              placeholder: "First Name*"
            },
            messageProps: {
              placeholder: "Your Message*"
            },
            country_id: 98
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-10 lg:mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "m-auto lg:col-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            data: data.dataFaqs,
            description: " "
          })
        })
      })
    })]
  });
};

/* harmony default export */ var accounting_and_auditing = (AccountingAndAuditing);
AccountingAndAuditing.defaultProps = {
  data: {}
};
;// CONCATENATED MODULE: ./pages/hk/accounting-and-auditing/data.json
var data_namespaceObject = JSON.parse('{"dataFaqs":[{"name":"What accounting software do you use?","content":"<p>We use cloud accounting Xero, a cloud-based, secured, easy access via the internet software. Using this, authorized users can obtain current, precise financial data almost everywhere, anytime.</p>"},{"name":"Does a dormant company need to do annual auditing?","content":"<p>A dormant company is still required to conduct accounting and get books audited annually. However, under certain conditions, that company can be exempted from auditing. You can find more information in <a rel=\'noopener noreferrer\' target=\'_blank\' href=\'https://bbcincorp.com/hk/articles/hong-kong-dormant-company\'>Hong Kong dormant company</a> blog post.</p>"},{"name":"How can I submit my data?","content":"<p>You can opt to send your data via multiple methods including mail, cloud storage, or you can grant us remote access to your internal accounting system. Be assured that your financial records will be treated confidentially. We make sure to keep and satisfy your benefits.</p>"}],"serviceFees":[{"key":"accounting","name":"accounting","currencySymbol":"US$","xero":{"value":25,"default":false},"default_type":1,"types":[{"key":"monthly","name":"monthly","transactionUnitText":"Transactions per month","pricePer":"month","costFor":"both accounting and auditing","currencySymbol":"US$","transaction":{"min":1,"max":1000,"step":1,"note":""},"pricing":[{"value":10,"price":120},{"value":20,"price":160},{"value":30,"price":220},{"value":40,"price":280},{"value":50,"price":340},{"value":60,"price":340},{"value":70,"price":390},{"value":80,"price":440},{"value":90,"price":490},{"value":100,"price":540},{"value":125,"price":590},{"value":150,"price":700},{"value":175,"price":705},{"value":200,"price":800},{"value":300,"price":1000},{"value":400,"price":1080},{"value":500,"price":1040},{"value":600,"price":1120},{"value":700,"price":1160},{"value":800,"price":1160},{"value":900,"price":1120},{"value":1000,"price":1040}],"content":["Monthly accounting review","Xero cloud accounting","Monthly preparation of FSs"]},{"key":"yearly","name":"yearly","transactionUnitText":"Transactions per month","pricePer":"month","costFor":"both accounting and auditing","currencySymbol":"US$","transaction":{"min":1,"max":1000,"step":1,"note":""},"pricing":[{"value":10,"price":40},{"value":20,"price":60},{"value":30,"price":90},{"value":40,"price":120},{"value":50,"price":150},{"value":60,"price":150},{"value":70,"price":175},{"value":80,"price":200},{"value":90,"price":225},{"value":100,"price":250},{"value":125,"price":275},{"value":150,"price":330},{"value":175,"price":332.5},{"value":200,"price":380},{"value":300,"price":480},{"value":400,"price":520},{"value":500,"price":500},{"value":600,"price":540},{"value":700,"price":560},{"value":800,"price":560},{"value":900,"price":540},{"value":1000,"price":500}],"content":["Xero cloud accounting","A Yearly compilation of FSs"]}]},{"key":"auditing","name":"auditing","currencySymbol":"US$","exchangeRate":1,"revenue":{"min":0,"max":20000000},"types":[{"key":"hkd","name":"HKD","pricePer":false,"costFor":"both accounting and auditing","currencySymbol":"US$","exchangeRate":7.78,"revenue":{"step":0.01,"note":""},"format":{"value":1000000,"unit":"mil"},"rounded":2},{"key":"usd","name":"USD","pricePer":false,"costFor":"both accounting and auditing","currencySymbol":"US$","exchangeRate":1,"revenue":{"step":1,"note":""},"format":{"value":1,"unit":false},"rounded":0}],"pricing":[{"value":3999999,"price":false,"minPrice":850,"percent":0.06},{"value":7999999,"price":false,"minPrice":850,"percent":0.05},{"value":20000000,"price":false,"minPrice":850,"percent":0.04}],"pricingLevel":true,"content":""}]}');
;// CONCATENATED MODULE: ./pages/hk/accounting-and-auditing/index.js




var __N_SSG = true;
function AccountingAndTaxation(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "hk",
      page: data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(accounting_and_auditing, {
        data: data_namespaceObject
      })
    })
  });
}

/***/ }),

/***/ 76519:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hk/accounting-and-auditing",
      function () {
        return __webpack_require__(18695);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ToastContent":"Index_ToastContent__WZ1XO"};

/***/ }),

/***/ 36913:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sfc_slider":"Index_sfc_slider__NGZR8","inputNumber":"Index_inputNumber__Z9Wst","switch":"Index_switch__spPnt","paymentType":"Index_paymentType__zw0XW"};

/***/ }),

/***/ 23096:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 34853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ }),

/***/ 49768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ usePopperTooltip; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88298);





function useGetLatest(val) {
  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(val);
  ref.current = val;
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    return ref.current;
  }, []);
}

var noop = function noop() {// do nothing
};

function useControlledState(_ref) {
  var initial = _ref.initial,
      value = _ref.value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange;

  if (initial === undefined && value === undefined) {
    throw new TypeError('Either "value" or "initial" variable must be set. Now both are undefined');
  }

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(initial),
      state = _React$useState[0],
      setState = _React$useState[1];

  var getLatest = useGetLatest(state);
  var set = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (updater) {
    var state = getLatest();
    var updatedState = typeof updater === 'function' ? updater(state) : updater;
    if (typeof updatedState.persist === 'function') updatedState.persist();
    setState(updatedState);
    if (typeof onChange === 'function') onChange(updatedState);
  }, [getLatest, onChange]);
  var isControlled = value !== undefined;
  return [isControlled ? value : state, isControlled ? onChange : set];
}
function generateBoundingClientRect(x, y) {
  if (x === void 0) {
    x = 0;
  }

  if (y === void 0) {
    y = 0;
  }

  return function () {
    return {
      width: 0,
      height: 0,
      top: y,
      right: x,
      bottom: y,
      left: x,
      x: 0,
      y: 0,
      toJSON: function toJSON() {
        return null;
      }
    };
  };
}

var _excluded = ["styles", "attributes"];
var virtualElement = {
  getBoundingClientRect: generateBoundingClientRect()
};
var defaultConfig = {
  closeOnOutsideClick: true,
  closeOnTriggerHidden: false,
  defaultVisible: false,
  delayHide: 0,
  delayShow: 0,
  followCursor: false,
  interactive: false,
  mutationObserverOptions: {
    attributes: true,
    childList: true,
    subtree: true
  },
  offset: [0, 6],
  trigger: 'hover'
};
function usePopperTooltip(config, popperOptions) {
  var _popperProps$state, _popperProps$state$mo, _popperProps$state$mo2;

  if (config === void 0) {
    config = {};
  }

  if (popperOptions === void 0) {
    popperOptions = {};
  }

  // Merging options with default options.
  // Keys with undefined values are replaced with the default ones if any.
  // Keys with other values pass through.
  var finalConfig = Object.keys(defaultConfig).reduce(function (config, key) {
    var _extends2;

    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, config, (_extends2 = {}, _extends2[key] = config[key] !== undefined ? config[key] : defaultConfig[key], _extends2));
  }, config);
  var defaultModifiers = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return [{
      name: 'offset',
      options: {
        offset: finalConfig.offset
      }
    }];
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(finalConfig.offset) ? finalConfig.offset : []);

  var finalPopperOptions = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, popperOptions, {
    placement: popperOptions.placement || finalConfig.placement,
    modifiers: popperOptions.modifiers || defaultModifiers
  });

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(null),
      triggerRef = _React$useState[0],
      setTriggerRef = _React$useState[1];

  var _React$useState2 = react__WEBPACK_IMPORTED_MODULE_0__.useState(null),
      tooltipRef = _React$useState2[0],
      setTooltipRef = _React$useState2[1];

  var _useControlledState = useControlledState({
    initial: finalConfig.defaultVisible,
    value: finalConfig.visible,
    onChange: finalConfig.onVisibleChange
  }),
      visible = _useControlledState[0],
      setVisible = _useControlledState[1];

  var timer = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    return function () {
      return clearTimeout(timer.current);
    };
  }, []);

  var _usePopper = (0,react_popper__WEBPACK_IMPORTED_MODULE_2__/* .usePopper */ .D)(finalConfig.followCursor ? virtualElement : triggerRef, tooltipRef, finalPopperOptions),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      popperProps = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_usePopper, _excluded);

  var update = popperProps.update;
  var getLatest = useGetLatest({
    visible: visible,
    triggerRef: triggerRef,
    tooltipRef: tooltipRef,
    finalConfig: finalConfig
  });
  var isTriggeredBy = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (trigger) {
    return Array.isArray(finalConfig.trigger) ? finalConfig.trigger.includes(trigger) : finalConfig.trigger === trigger;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(finalConfig.trigger) ? finalConfig.trigger : [finalConfig.trigger]);
  var hideTooltip = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    clearTimeout(timer.current);
    timer.current = window.setTimeout(function () {
      return setVisible(false);
    }, finalConfig.delayHide);
  }, [finalConfig.delayHide, setVisible]);
  var showTooltip = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    clearTimeout(timer.current);
    timer.current = window.setTimeout(function () {
      return setVisible(true);
    }, finalConfig.delayShow);
  }, [finalConfig.delayShow, setVisible]);
  var toggleTooltip = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    if (getLatest().visible) {
      hideTooltip();
    } else {
      showTooltip();
    }
  }, [getLatest, hideTooltip, showTooltip]); // Handle click outside

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (!getLatest().finalConfig.closeOnOutsideClick) return;

    var handleClickOutside = function handleClickOutside(event) {
      var _event$composedPath;

      var _getLatest = getLatest(),
          tooltipRef = _getLatest.tooltipRef,
          triggerRef = _getLatest.triggerRef;

      var target = (event.composedPath == null ? void 0 : (_event$composedPath = event.composedPath()) == null ? void 0 : _event$composedPath[0]) || event.target;

      if (target instanceof Node) {
        if (tooltipRef != null && triggerRef != null && !tooltipRef.contains(target) && !triggerRef.contains(target)) {
          hideTooltip();
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [getLatest, hideTooltip]); // Trigger: click

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (triggerRef == null || !isTriggeredBy('click')) return;
    triggerRef.addEventListener('click', toggleTooltip);
    return function () {
      return triggerRef.removeEventListener('click', toggleTooltip);
    };
  }, [triggerRef, isTriggeredBy, toggleTooltip]); // Trigger: double-click

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (triggerRef == null || !isTriggeredBy('double-click')) return;
    triggerRef.addEventListener('dblclick', toggleTooltip);
    return function () {
      return triggerRef.removeEventListener('dblclick', toggleTooltip);
    };
  }, [triggerRef, isTriggeredBy, toggleTooltip]); // Trigger: right-click

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (triggerRef == null || !isTriggeredBy('right-click')) return;

    var preventDefaultAndToggle = function preventDefaultAndToggle(event) {
      // Don't show the context menu
      event.preventDefault();
      toggleTooltip();
    };

    triggerRef.addEventListener('contextmenu', preventDefaultAndToggle);
    return function () {
      return triggerRef.removeEventListener('contextmenu', preventDefaultAndToggle);
    };
  }, [triggerRef, isTriggeredBy, toggleTooltip]); // Trigger: focus

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (triggerRef == null || !isTriggeredBy('focus')) return;
    triggerRef.addEventListener('focus', showTooltip);
    triggerRef.addEventListener('blur', hideTooltip);
    return function () {
      triggerRef.removeEventListener('focus', showTooltip);
      triggerRef.removeEventListener('blur', hideTooltip);
    };
  }, [triggerRef, isTriggeredBy, showTooltip, hideTooltip]); // Trigger: hover on trigger

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (triggerRef == null || !isTriggeredBy('hover')) return;
    triggerRef.addEventListener('mouseenter', showTooltip);
    triggerRef.addEventListener('mouseleave', hideTooltip);
    return function () {
      triggerRef.removeEventListener('mouseenter', showTooltip);
      triggerRef.removeEventListener('mouseleave', hideTooltip);
    };
  }, [triggerRef, isTriggeredBy, showTooltip, hideTooltip]); // Trigger: hover on tooltip, keep it open if hovered

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (tooltipRef == null || !isTriggeredBy('hover') || !getLatest().finalConfig.interactive) return;
    tooltipRef.addEventListener('mouseenter', showTooltip);
    tooltipRef.addEventListener('mouseleave', hideTooltip);
    return function () {
      tooltipRef.removeEventListener('mouseenter', showTooltip);
      tooltipRef.removeEventListener('mouseleave', hideTooltip);
    };
  }, [tooltipRef, isTriggeredBy, showTooltip, hideTooltip, getLatest]); // Handle closing tooltip if trigger hidden

  var isReferenceHidden = popperProps == null ? void 0 : (_popperProps$state = popperProps.state) == null ? void 0 : (_popperProps$state$mo = _popperProps$state.modifiersData) == null ? void 0 : (_popperProps$state$mo2 = _popperProps$state$mo.hide) == null ? void 0 : _popperProps$state$mo2.isReferenceHidden;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (finalConfig.closeOnTriggerHidden && isReferenceHidden) hideTooltip();
  }, [finalConfig.closeOnTriggerHidden, hideTooltip, isReferenceHidden]); // Handle follow cursor

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (!finalConfig.followCursor || triggerRef == null) return;

    function setMousePosition(_ref) {
      var clientX = _ref.clientX,
          clientY = _ref.clientY;
      virtualElement.getBoundingClientRect = generateBoundingClientRect(clientX, clientY);
      update == null ? void 0 : update();
    }

    triggerRef.addEventListener('mousemove', setMousePosition);
    return function () {
      return triggerRef.removeEventListener('mousemove', setMousePosition);
    };
  }, [finalConfig.followCursor, triggerRef, update]); // Handle tooltip DOM mutation changes (aka mutation observer)

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (tooltipRef == null || update == null || finalConfig.mutationObserverOptions == null) return;
    var observer = new MutationObserver(update);
    observer.observe(tooltipRef, finalConfig.mutationObserverOptions);
    return function () {
      return observer.disconnect();
    };
  }, [finalConfig.mutationObserverOptions, tooltipRef, update]); // Tooltip props getter

  var getTooltipProps = function getTooltipProps(args) {
    if (args === void 0) {
      args = {};
    }

    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, args, {
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, args.style, styles.popper)
    }, attributes.popper, {
      'data-popper-interactive': finalConfig.interactive
    });
  }; // Arrow props getter


  var getArrowProps = function getArrowProps(args) {
    if (args === void 0) {
      args = {};
    }

    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, args, attributes.arrow, {
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, args.style, styles.arrow),
      'data-popper-arrow': true
    });
  };

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    getArrowProps: getArrowProps,
    getTooltipProps: getTooltipProps,
    setTooltipRef: setTooltipRef,
    setTriggerRef: setTriggerRef,
    tooltipRef: tooltipRef,
    triggerRef: triggerRef,
    visible: visible
  }, popperProps);
}


//# sourceMappingURL=react-popper-tooltip.js.map


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9010,3105,9593,9885,5955,4090,9738,7447,9156,9774,2888,179], function() { return __webpack_exec__(76519); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);